export type SpecialistDecisionType =
  "ACCEPT_SYSTEM" | "SELECT_ALTERNATIVE" | "SINGLE_SOURCE";

export type SpecialistDecisionInput = {
  requestNo: string;
  evaluationId: string;
  decisionType: SpecialistDecisionType;
  offerId?: string;
  rationale?: string;
};

export type SpecialistDecisionResult<TRecommendation> = {
  recommendation: TRecommendation;
};

export type SpecialistDecisionGateway = {
  saveRecommendation<TRecommendation>(
    input: SpecialistDecisionInput,
  ): Promise<TRecommendation>;
  routeToManager(requestNo: string): Promise<void>;
};

const inFlightRequests = new Set<string>();

export function createSubmitSpecialistDecision(
  gateway: SpecialistDecisionGateway,
) {
  return async function submitSpecialistDecision<TRecommendation>(
    input: SpecialistDecisionInput,
  ): Promise<SpecialistDecisionResult<TRecommendation>> {
    if ((input.rationale?.trim().length ?? 0) < 10) {
      throw new Error(
        "Satın Alma Uzmanı önerisi için en az 10 karakterlik gerekçe zorunludur.",
      );
    }

    if (inFlightRequests.has(input.requestNo)) {
      throw new Error("Bu talep için karar zaten gönderiliyor.");
    }

    inFlightRequests.add(input.requestNo);
    try {
      const recommendation =
        await gateway.saveRecommendation<TRecommendation>(input);
      await gateway.routeToManager(input.requestNo);
      return { recommendation };
    } finally {
      inFlightRequests.delete(input.requestNo);
    }
  };
}
